import {forMs} from "../util/AsyncUtils";

class DocsService {
    private chars: string = "\n\nabchijklmnoprstdefghijklmnoprstuvwxyzabcdefghijklmnoprstuvwxyz         "

    async getContent(menuId: string, menuName: string): Promise<string> {
        let str = ""
        const count = randi(1000) + 2000;
        for (let i = 0; i < count; i++) {
            str = str.concat(this.rchar())
        }

        await forMs(50)

        return "<b>" + menuName + "</b> (<i>" + menuId + "</i>)<br><br/>" + str
    }

    private rchar(): string {
        const ri = randi(this.chars.length - 1)
        if (ri < 2) {
            return "<br>"
        }
        return this.chars.charAt(ri)
    }
}

function randi(bound: number) {
    return Math.round(Math.random() * bound)
}

const docsService = new DocsService()
export default docsService